import { TEAM_PLAN_INCLUDED_PRO_ACCOUNTS } from "modules/Const"
import ModalSymphony from "elements/ModalSymphony"
import ButtonSymphony from "elements/ButtonSymphony"
import useOrganization from "Hooks/useOrganization"

interface ConfirmChangeSubscriptionModalProps {
    brandName: string | undefined
    buttonLoading?: boolean
    isTeamAdmin?: boolean
    onClose: () => void
    onConfirm: () => void
    isOpen: boolean
    type?: 'upgrade' | 'downgrade'
}

const ConfirmChangeSubscriptionModal = ({
    brandName = '',
    buttonLoading,
    isTeamAdmin,
    onClose,
    onConfirm,
    isOpen,
    type,
}: ConfirmChangeSubscriptionModalProps) => {
    const { proAccountsCount } = useOrganization()
    const proAccountsCountLocal = proAccountsCount()

    const getTitle = () => {
        if (type === 'downgrade') {
            return `Downgrade to Free: ${brandName}`
        }
        return `Upgrade to Pro: ${brandName}`
    }

    const getSubtitle = () => {
        if (!isTeamAdmin) {
            return 'Please contact your Team Admin to upgrade to Pro and unlock this functionality.'
        }

        if (type === 'downgrade') {
            if (proAccountsCountLocal <= TEAM_PLAN_INCLUDED_PRO_ACCOUNTS) {
                return `This profile won't be able to create campaigns, view advanced analytics, or take Pro-only actions once downgraded. You'll have ${TEAM_PLAN_INCLUDED_PRO_ACCOUNTS - (proAccountsCountLocal - 1)} Pro account${TEAM_PLAN_INCLUDED_PRO_ACCOUNTS - (proAccountsCountLocal - 1) !== 1 ? 's' : ''} available.`
            }
            return `This profile won't be able to create campaigns or take Pro-only actions once downgraded. Your monthly bill will be reduced by $15.`
        }

        if (proAccountsCountLocal >= TEAM_PLAN_INCLUDED_PRO_ACCOUNTS) {
            return `Once upgraded, this profile will be able to create campaigns, view advanced analytics, and take Pro-only actions. Since you've used all ${TEAM_PLAN_INCLUDED_PRO_ACCOUNTS} team Pro account slots, you'll be charged $15/month for this profile.`
        }

        return `Once upgraded, this profile will be able to create campaigns, view advanced analytics, and take Pro-only actions. You'll have ${TEAM_PLAN_INCLUDED_PRO_ACCOUNTS - (proAccountsCountLocal + 1)} Pro account${TEAM_PLAN_INCLUDED_PRO_ACCOUNTS - (proAccountsCountLocal + 1) !== 1 ? 's' : ''} remaining.`
    }

    const getButtonCtaText = () => {
        if (type === 'downgrade') {
            return 'Confirm Downgrade'
        }
        return 'Confirm Upgrade'
    }

    return (
        <ModalSymphony
            className="confirmChangeSubscriptionModal"
            isOpen={isOpen}
            onClose={onClose}
            title={getTitle()}
            subtitle={getSubtitle()}
            headerIcon="user"
        >
            {isTeamAdmin ?
                <div style={{ display: 'flex', gap: 16, alignSelf: 'flex-end' }}>
                    <ButtonSymphony
                        className="cancelUpgradeToProOrgButton"
                        disabled={buttonLoading}
                        onClick={onClose}
                        variant="text"
                        color="grey"
                    >
                        Cancel
                    </ButtonSymphony>
                    <ButtonSymphony
                        className="confirmUpgradeToProOrgButton"
                        isLoading={buttonLoading}
                        disabled={buttonLoading}
                        onClick={onConfirm}
                        color={type === 'downgrade' ? 'purple' : 'green'}
                    >
                        {getButtonCtaText()}
                    </ButtonSymphony>
                </div>
                :
                <ButtonSymphony
                    className="confirmedUpgradeToProOrgButton"
                    isLoading={buttonLoading}
                    disabled={buttonLoading}
                    onClick={onClose}
                >
                    Got it
                </ButtonSymphony>
            }
        </ModalSymphony>
    )
}

export default ConfirmChangeSubscriptionModal

